import React, { useState } from "react";
import {
  Modal,
  Button,
  Form,
  Space,
  Result,
  Input,
  DatePicker,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { useStepsForm } from "sunflower-antd";

interface IModalProps {
  show: boolean;
  memberId: any;
  showModal: Function;
  handleAdd: Function;
  policyId: any;
}

const AddRefundModal: React.FC<IModalProps> = ({
  show,
  memberId,
  showModal,
  handleAdd,
  policyId,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleModal = () => {
    showModal();
    gotoStep(0);
    form.resetFields();
  };

  const {
    form,
    current,
    gotoStep,
    formProps,
    submit,
  } = useStepsForm({
    isBackValidate: false,
    async submit(values: any) {
      setLoading(true);

      const response = await handleAdd(
        {
          ...values,
          Amount: String(values.Amount),
          Type: "Refund",
        },
        policyId
      );

      if (response.success) {
        setLoading(false);
        return true;
      }
      setErrorMsg(response.message);
      setLoading(false);
      return false;
    },
    total: 3,
  });

  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 8 },
  };

  const tailLayout = {
    labelCol: { span: 0 },
    wrapperCol: { offset: 8, span: 8 },
  };

  const formList: any = [
    <>
      <Form.Item
        name="Amount"
        label="Amount"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" id="Amount" placeholder="Amount" />
      </Form.Item>
      <Form.Item
        label="Reference Number"
        name="Reference"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <Input size="large" id="Reference" placeholder="Reference Number" />
      </Form.Item>
      <Form.Item name="Note" label="Note">
        <TextArea size="large" id="Note" placeholder="Note" />
      </Form.Item>

      <Form.Item
        label="Refund Date"
        name="Date"
        rules={[
          {
            required: true,
          },
        ]}
      >
        <DatePicker
          id="Date"
          placeholder="Refund Date"
          size="large"
          style={{ width: "100%" }}
        />
      </Form.Item>

      <Form.Item {...tailLayout}>
        <Space direction="vertical" style={{ width: "100%" }}>
          <Button
            loading={loading}
            style={{ marginBottom: 10 }}
            block
            size="large"
            onClick={() => {
              submit().then((result: any) => {
                if (result) {
                  gotoStep(current + 1);
                } else if (!result) {
                  gotoStep(current + 2);
                }
              });
            }}
          >
            Submit
          </Button>
        </Space>
      </Form.Item>
    </>,
  ];

  return (
    <Modal
      title="Add Refund"
      open={show}
      onOk={handleModal}
      onCancel={handleModal}
      width={900}
      footer={null}
    >
      {/* Steps Form */}
      <div>
        <div style={{ marginTop: 60 }}>
          <Form {...layout} {...formProps} style={{ maxWidth: 900 }}>
            {formList[current]}
          </Form>

          {current === 1 && (
            <Result status="success" title="Successfully submitted.">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}

          {current === 2 && (
            <Result status="error" title={errorMsg}>
              <Space direction="vertical" style={{ width: "100%" }}>
                <Button block size="large" onClick={handleModal}>
                  Okay
                </Button>
              </Space>
            </Result>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default AddRefundModal;
